export default __webpack_public_path__ + "static/media/crash.4f562cd3.svg";